import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import CircularProgress from '@mui/material/CircularProgress';

const CustomRefreshButton = ({
    onClick,
    loading = false,
    label = "Refresh",
}) => {
    return (
        <Button
            variant="contained"
            onClick={onClick}              // ✅ use prop
            disabled={loading}             // ✅ use prop
            startIcon={
                loading ? (
                    <CircularProgress size={16} color="inherit" />
                ) : (
                    <RefreshIcon />
                )
            }
            sx={{
                backgroundColor: '#1976d2',
                color: '#ffffff',
                borderRadius: '8px',
                px: 3,
                py: 0.6,
                textTransform: 'none',
                fontWeight: 500,
                boxShadow: 'none',

                '&:hover': {
                    backgroundColor: '#1565c0',
                    boxShadow: 'none',
                },

                '&:disabled': {
                    backgroundColor: '#90caf9',
                    color: '#fff',
                },
            }}
        >
            {loading ? `${label}...` : label}
        </Button>
    );
}


export default CustomRefreshButton;